import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Landing from './pages/Landing';
import CustomizeOrder from './pages/CustomizeOrder';
import RepositionRequest from './pages/RepositionRequest';
import Payment from './pages/Payment';
import OrganizerDashboard from './pages/OrganizerDashboard';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentError from './pages/PaymentError';
import ProtectedRoute from './components/ProtectedRoute';
import PublicGroupRoute from './components/PublicGroupRoute';
import { Toaster } from 'react-hot-toast';
import OrderDetailsPage from './pages/OrderDetailsPage';
 
export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route 
          path="/order-details" 
          element={
            <ProtectedRoute allowedUserTypes={['member']}>
              <OrderDetailsPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/customize" 
          element={
            <PublicGroupRoute>
              <CustomizeOrder />
            </PublicGroupRoute>
          } 
        />
        <Route 
          path="/reposition" 
          element={
            <PublicGroupRoute>
              <RepositionRequest />
            </PublicGroupRoute>
          } 
        />
        <Route 
          path="/payment" 
          element={
            <ProtectedRoute allowedUserTypes={['member']}>
              <Payment />
            </ProtectedRoute>
          } 
        />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/error" element={<PaymentError />} />
        <Route 
          path="/organizer/dashboard" 
          element={
            <ProtectedRoute allowedUserTypes={['organizer']}>
              <OrganizerDashboard />
            </ProtectedRoute>
          } 
        />
      </Routes>
      <Toaster
        position="top-right"
        containerStyle={{
          zIndex: 100001,
        }}
        toastOptions={{
          duration: 4000,
          style: {
            background: '#363636',
            color: '#fff',
          },
          success: {
            style: {
              background: '#10B981',
              color: '#fff',
            },
          },
          error: {
            style: {
              background: '#EF4444',
              color: '#fff',
            },
          },
        }}
      />
    </Router>
  );
}